"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var usersTemplateSent = function () {
    return {
        status: true,
        mailsHistory: [
            {
                sentTo: 'a@codebashing.com',
                sentAt: new Date().toLocaleDateString(),
                senderEmail: 'sender@test.test',
            },
            {
                sentTo: 'b@codebashing.com',
                sentAt: new Date().toLocaleDateString(),
                senderEmail: 'sender@test.test',
            },
            {
                sentTo: 'c@codebashing.com',
                sentAt: new Date().toLocaleDateString(),
                senderEmail: 'sender@test.test',
            },
            {
                sentTo: 'd@codebashing.com',
                sentAt: new Date().toLocaleDateString(),
                senderEmail: 'sender@test.test',
            },
            {
                sentTo: 'e@codebashing.com',
                sentAt: new Date().toLocaleDateString(),
                senderEmail: 'sender@test.test',
            },
            {
                sentTo: 'f@codebashing.com',
                sentAt: new Date().toLocaleDateString(),
                senderEmail: 'sender@test.test',
            },
        ],
    };
};
exports.default = usersTemplateSent;
